const mutations = {
  'SET_DELIVERIES'(state, value) {
    state.deliveries = value
  },
  'SET_COUNT_STATUS'(state, value) {
    state.countStatus = value
  },
  'SET_DELIVERY_SELECTED'(state, value) {
    state.deliverySelected = value
  },
  'SET_TAB_SELECTED'(state, value) {
    state.saveTabSelected = value
  },
  'SET_PARTNER_ERROR_COUNT'(state, count) {
    state.partnerErrorCount = count
  },
  'SET_DRIVER_DELIVERY_COUNTERS'(state, value) {
    state.driverDeliveryCounters = value
  },
}
export default mutations
